import { render, staticRenderFns } from "./AssigneesSelection.vue?vue&type=template&id=08fff496&scoped=true"
import script from "./AssigneesSelection.vue?vue&type=script&lang=js"
export * from "./AssigneesSelection.vue?vue&type=script&lang=js"
import style0 from "./AssigneesSelection.vue?vue&type=style&index=0&id=08fff496&prod&scoped=true&lang=scss"
import style1 from "./AssigneesSelection.vue?vue&type=style&index=1&id=08fff496&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fff496",
  null
  
)

export default component.exports